import { render, staticRenderFns } from "./public.component.vue?vue&type=template&id=504ae6b3&"
import script from "./public.component.js?vue&type=script&lang=js&"
export * from "./public.component.js?vue&type=script&lang=js&"
import style0 from "./public.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VMain,VSlideXTransition})
